(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$('form[data-submit-onchange]').on('change', function () {
		$(this).submit();
	});
})();
